import {
    PIN_TITLE_AND_TYPE,
    ALL_SAVED_PIN_NAV_ITEM,
    PIN_TYPE_PARAM_NAME,
} from '~/modules/design-board/config';
import type {
    PinTypeCountData,
    SideNavItems,
} from '~/modules/design-board/type/design-board-types';

export const getSideNavLinksByPins = (
    pinCounts: PinTypeCountData,
    mobile = false
): SideNavItems[] => {
    let existTypes = PIN_TITLE_AND_TYPE.filter((item) => {
        return pinCounts[item.type] > 0;
    });

    existTypes = existTypes.length > 0 ? existTypes : PIN_TITLE_AND_TYPE;

    const newItems = existTypes.map(
        (item): SideNavItems => ({
            title: item.title,
            link: `?${PIN_TYPE_PARAM_NAME}=${item.type}`,
            type: item.type,
        })
    );

    if (newItems.length > 1 && !mobile) {
        return [ALL_SAVED_PIN_NAV_ITEM, ...newItems];
    }

    return newItems;
};
